// extracted by mini-css-extract-plugin
export var disabled = "CalculateButton-module--disabled--2FlJr";
export var active = "CalculateButton-module--active--3AZdU";
export var fadeIn = "CalculateButton-module--fadeIn--3icmt";
export var moveLeft = "CalculateButton-module--moveLeft--3W2Y-";
export var moveDown = "CalculateButton-module--moveDown--1IIIP";
export var illuMoveDown = "CalculateButton-module--illuMoveDown--1z4Px";